<template>
  <div class="listBox">
    <!-- 搜索条件 -->
    <ul class="sBox">
      <el-select
        v-model="state.params.status"
        placeholder="订单状态"
        clearable
        style="width: 120px"
        @change="onLoad"
      >
        <el-option label="全部" value="" />
        <el-option label="待使用" value="待使用" />
        <el-option label="已完成" value="已完成" />
      </el-select>
      <el-select
        v-model="state.params.category"
        placeholder="商品品类"
        clearable
        style="width: 130px; margin-left: 10px"
        @change="onLoad"
      >
        <el-option
          v-for="item in state.categories"
          :key="item"
          :label="item"
          :value="item"
        />
      </el-select>
      <el-input
        v-model="state.params.spName"
        placeholder="商品名称"
        clearable
        style="width: 160px; margin-left: 10px"
        @clear="onLoad"
        @keyup.enter="onLoad"
      />
      <el-date-picker
        v-model="state.startDate"
        type="date"
        placeholder="开始日期"
        value-format="YYYY-MM-DD"
        style="width: 120px; margin-left: 10px"
      />
      <span style="margin: 0 5px">至</span>
      <el-date-picker
        v-model="state.endDate"
        type="date"
        placeholder="结束日期"
        value-format="YYYY-MM-DD"
        style="width: 120px"
      />
      <el-dropdown
        split-button
        @click="onLoad"
        type="primary"
        style="margin: 0 10px"
      >
        查询
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item :icon="RefreshLeft" @click="onReset">
              重置
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
      <!-- 穿透来源提示 -->
      <el-tag v-if="state.drillInfo" type="warning" closable @close="clearDrill">
        {{ state.drillInfo }}
      </el-tag>
    </ul>

    <!-- 数据表格 -->
    <ul class="tBox">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        show-summary
        :summary-method="getSummaries"
        style="width: 100%"
      >
        <el-table-column
          label="#"
          width="50"
          type="index"
          :index="(i) => (state.params.page - 1) * state.params.limit + i + 1"
          align="center"
        />
        <el-table-column prop="Bh" label="订单编号" min-width="140" show-overflow-tooltip />
        <el-table-column prop="SpPlMc" label="品类" width="100" />
        <el-table-column prop="SpMc" label="商品名称" min-width="180" show-overflow-tooltip />
        <el-table-column prop="SpTcMc" label="套餐" min-width="120" show-overflow-tooltip />
        <el-table-column prop="Ly" label="来源" width="120" />
        <el-table-column label="状态" width="85" align="center">
          <template #default="{ row }">
            <el-tag :type="row.DdZt === '已完成' ? 'success' : 'warning'" size="small">{{ row.DdZt }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="KhMc" label="客户" min-width="80" show-overflow-tooltip />
        <el-table-column prop="Sl" label="数量" width="60" align="center" />
        <el-table-column prop="Cps" label="已出票" width="70" align="center" />
        <el-table-column prop="Xszj" label="销售总价" width="90" align="right" />
        <el-table-column prop="Jszj" label="结算总价" width="90" align="right" />
        <el-table-column prop="SxfJe" label="手续费" width="90" align="right">
          <template #default="{ row }">
            <span v-if="Number(row.SxfJe) > 0">{{ row.SxfJe }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="Fxje" label="分销返佣" width="90" align="right">
          <template #default="{ row }">
            <span v-if="Number(row.Fxje) > 0">{{ row.Fxje }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="Lr" label="利润" width="90" align="right">
          <template #default="{ row }">
            <span :style="{ color: Number(row.Lr) >= 0 ? '#67c23a' : '#f56c6c' }">
              {{ row.Lr }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="Syrq" label="使用日期" width="110" align="center" />
        <el-table-column prop="Cjsj" label="下单时间" width="170" align="center" />
        <el-table-column label="对账" width="70" align="center">
          <template #default="{ row }">
            <el-tag :type="row.IsDz ? 'success' : 'info'" size="small">
              {{ row.IsDz ? '已对账' : '未对账' }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
    </ul>

    <!-- 分页 -->
    <c_page
      :total="state.totalCount"
      :pageIndex="state.params.page"
      @onLoad="(p) => { state.params.page = p; onLoad(); }"
    />
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { caiwu_spdd_mingxi, caiwu_spdd_mingxi_categories } from "@/http/api";

export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const state = reactive({
      params: {
        page: 1,
        limit: 20,
        status: null,
        category: null,
        spName: null,
        startDate: null,
        endDate: null,
      },
      dateRange: null,
      startDate: null,
      endDate: null,
      tableData: undefined,
      totalCount: 0,
      categories: [],
      drillInfo: null,
      summary: null,  // 后端返回的汇总数据
    });

    // 加载品类下拉
    const loadCategories = () => {
      caiwu_spdd_mingxi_categories().then((res) => {
        if (res.status == 200) state.categories = res.data;
      });
    };

    // 从穿透参数初始化搜索条件
    const initFromDrill = () => {
      const d = props.data;
      if (!d) return;

      let info = [];

      if (d.startDate || d.endDate) {
        state.startDate = d.startDate;
        state.endDate = d.endDate;
        state.params.startDate = d.startDate;
        state.params.endDate = d.endDate;
        info.push(`${d.startDate} ~ ${d.endDate}`);
      }

      if (d.category) {
        state.params.category = d.category;
        info.push(`品类: ${d.category}`);
      }

      if (d.spName) {
        state.params.spName = d.spName;
        info.push(`商品: ${d.spName}`);
      }

      if (info.length > 0) {
        state.drillInfo = "穿透条件: " + info.join(" | ");
      }
    };

    // 清除穿透条件
    const clearDrill = () => {
      state.params.category = null;
      state.params.status = null;
      state.params.startDate = null;
      state.params.endDate = null;
      state.params.spName = null;
      state.startDate = null;
      state.endDate = null;
      state.drillInfo = null;
      onLoad();
    };

    // 加载数据
    const onLoad = () => {
      delete state.tableData;

      // 同步独立日期到参数
      state.params.startDate = state.startDate || null;
      state.params.endDate = state.endDate || null;

      caiwu_spdd_mingxi(state.params).then((res) => {
        if (res.status == 200) {
          state.tableData = res.data.data;
          state.totalCount = res.data.total;
          state.summary = res.data.summary;  // 保存后端汇总
        }
      });
    };

    // 重置
    const onReset = () => {
      state.params = {
        page: 1,
        limit: 20,
        status: null,
        category: null,
        spName: null,
        startDate: null,
        endDate: null,
      };
      state.startDate = null;
      state.endDate = null;
      state.drillInfo = null;
      onLoad();
    };

    // 计算金额列合计（使用后端返回的汇总数据，与 Dashboard 保持一致）
    const getSummaries = (param) => {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        // 使用后端返回的汇总数据
        if (column.property === 'Xszj' && state.summary) {
          sums[index] = state.summary.Xszj;
        } else if (column.property === 'Jszj' && state.summary) {
          sums[index] = state.summary.Jszj;
        } else if (column.property === 'SxfJe' && state.summary) {
          sums[index] = state.summary.Sxf;
        } else if (column.property === 'Fxje' && state.summary) {
          sums[index] = state.summary.Fx;
        } else if (column.property === 'Lr' && state.summary) {
          sums[index] = state.summary.Lr;
        }
      });
      return sums;
    };

    onMounted(() => {
      loadCategories();
      initFromDrill();
      onLoad();
    });

    return { state, onLoad, onReset, clearDrill, getSummaries };
  },
};
</script>

<style scoped>
.listBox {
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #f6f6f6;
  padding: 10px;
}
.sBox {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0;
  margin-bottom: 10px;
  background: #fff;
  padding: 15px;
  border-radius: 7px;
}
.tBox {
  background: #fff;
  padding: 10px;
  border-radius: 7px;
  margin-bottom: 10px;
}
</style>
